import { render, staticRenderFns } from "./videoCoursePop.vue?vue&type=template&id=782b505a&scoped=true"
import script from "./videoCoursePop.vue?vue&type=script&lang=js"
export * from "./videoCoursePop.vue?vue&type=script&lang=js"
import style0 from "./videoCoursePop.vue?vue&type=style&index=0&id=782b505a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b505a",
  null
  
)

export default component.exports